import { component } from "picoapp";
export const OPTION_SELECTION = "option-selection";

export const subscriptionBox = component((node: HTMLElement) => {
  const productId = node.dataset.productId;
  if (!productId) return;

  const sellingPlanInput = node.querySelector<HTMLInputElement>(
    "[name='selling_plan']"
  );

  node
    .querySelectorAll(`input[name="selling_plan_select"]`)
    .forEach((frequencySelect) => {
      frequencySelect.addEventListener("change", function (e) {
        const selected = node.querySelector<HTMLInputElement>(
          `input[name="selling_plan_select"]:checked`
        );

        const plansSelect =
          node.querySelectorAll<HTMLElement>(`.rtx_option_plans`);
        if (selected.value === "onetime") {
          plansSelect.forEach((plans) => {
            plans.style.display = "none";
          });
          sellingPlanInput.value = "";
        } else {
          plansSelect.forEach((plans) => {
            plans.style.display = "block";
          });

          const sellingPlanOption = node.querySelector<HTMLSelectElement>(
            "#rtx_option_plans_dropdown"
          );

          const sellingPlanId = sellingPlanOption?.value;
          sellingPlanInput.value = sellingPlanId;
        }

        const changeEvent = new Event("change");
        sellingPlanInput.dispatchEvent(changeEvent);

        submitGAEvent(selected.value);
      });
    });

  sellingPlanInput.addEventListener(
    "change",
    (
      e: Event & {
        target: HTMLInputElement;
      }
    ) => {
      const subscriptionPlanId = e.target.value;
      const optionElement = node.querySelector<HTMLOptionElement>(
        `option[value='${subscriptionPlanId}']`
      );
      const frequencyText = optionElement?.innerHTML;
      window.dispatchEvent(
        new CustomEvent(OPTION_SELECTION, {
          detail: {
            subscriptionPlanId,
            frequencyText,
          },
        })
      );
    }
  );

  const submitGAEvent = (value: string) => {
    if (window.gtag) {
      window.gtag("event", "Subscription Selection", {
        event_detail: value === "onetime" ? "One Time" : "Subscribe & Save",
      });
    }
  };
});
